module.exports = __webpack_public_path__ + "components/incentive/static/unlock-5db8b4a01ae10527d74434df3f943c09.png";